import jStat from 'jstat';

export interface RangeResult {
  range: number;
  min: number;
  max: number;
  data: number[];
  interpretation: string;
}

export function calculateRange(data: number[]): RangeResult {
  const sortedData = [...data].sort((a, b) => a - b);
  const min = jStat.min(data);
  const max = jStat.max(data);
  const range = max - min;
  
  return {
    range,
    min,
    max,
    data: sortedData,
    interpretation: `The range is ${range.toFixed(2)}, spanning from the minimum value (${min.toFixed(2)}) to the maximum value (${max.toFixed(2)}). This shows the total spread of the data.`
  };
} 